import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { I18nValue } from '@gspwidget/util';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';


/** æ¯æçè¯­è¨ */
export class Lang {
  constructor (
    public code: string,
    public name: string
  ) {}
}

export class I18N_INPUT_CONFIG {
  langs: Promise<Lang[]> | Lang[]
}

/**
 * å½åæ§ä»¶è¿åç valueï¼æ¯ä¸ä¸ªæ°å¼ç¨åï¼
 * è¿æ¯åå¼ç¨ï¼æ´æ¹äºåé¨å¼?
 * æ¬æ¥ç¨äºåèãç°å¨æç®æ¹ä¸ºåé¢çè¯è¯ï¼è¿æ²¡æ¹ã
 */
@Component({
  selector: 'lib-i18n-input',
  templateUrl: './i18n-input.component.html',
  styleUrls: ['./i18n-input.component.scss']
})
export class I18nInputComponent implements OnChanges {

  @Input() placeholder: string
  /** TODO: ä¼åï¼å¾å¤ç */
  @Input() value: I18nValue | string
  @Input() required = false
  @Input() maxLength = false
  @Input() valueChangeOnBlur = true
  @Output() valueChange = new EventEmitter<I18nValue>()
  @ViewChild('mainInput') mainInput: NgModel
  // è¿ä¸ªç»å¤é¢ç
  valid: boolean

  innerValue: I18nValue = new I18nValue()
  tempValue: I18nValue = new I18nValue()
  curLang: string
  showingDropdown = false

  // langs: Lang[] = [{
  //   code: 'zh-CHS',
  //   name: 'chinese'
  // }, {
  //   code: 'en',
  //   name: 'english'
  // }]
  langs: Lang[] = []
  orderedLangs

  constructor (
    public translate: TranslateService,
    public cd: ChangeDetectorRef,
    @Optional() public config: I18N_INPUT_CONFIG
  ) {
    this.curLang = this.translate.currentLang
    // çå¬è¯­è¨æ¹ååè®¾ç½®
    this.translate.onLangChange.subscribe((e: LangChangeEvent) => this.setMainLang(e.lang))
    // ä» config ä¸­è·åå½åæ¯æè¯­è¨åè¡¨
    if (config && config.langs) {
      if (config.langs['then']) {
        (config.langs as Promise<Lang[]>).then(langs => this.setLangs(langs))
      } else {
        this.setLangs(config.langs as Lang[])
      }
    }
  }

  ngAfterViewInit () {
    this.mainInput.statusChanges.subscribe(status => {
      this.valid = status === 'VALID'
    })
  }
  setLangs (langs: Lang[]) {
    this.langs = langs
    this.setMainLang(this.translate.currentLang)
  }
  /** æ¹åé¡ºåºãå¾æ¹è¿ï¼å ä¸ºåªæè°äºå®å¯ä»¥æ´æ° html */
  setMainLang (lang: string) {
    this.curLang = lang
    const i = this.langs.findIndex(l => l.code === lang)
    this.orderedLangs = this.langs.slice()
    moveItemInArray(this.orderedLangs, i, 0)
  }

  ngOnChanges (changes: SimpleChanges): void {
    if (changes.value.currentValue !== changes.value.previousValue) {
      const value = (typeof this.value === 'string' || !this.value)
        ? { [this.translate.currentLang]: this.value }
        : this.value
      this.innerValue = { ...value }
      this.tempValue = { ...value }
    }
  }
  handleInputChange () {
    this.valueChange.emit(this.innerValue)
    this.tempValue = { ...this.innerValue }
  }
  handleConfirm () {
    this.innerValue = { ...this.tempValue }
    this.valueChange.emit(this.innerValue)
    this.showingDropdown = false
  }
  handleCancel () {
    this.tempValue = { ...this.innerValue }
    this.showingDropdown = false
  }

}
